import React, { useState } from "react";
import PrimaryButton from "../../../../partials/Buttons/PrimaryButton";
import CancelButton from "../../../../partials/Buttons/CancelButton";
import renderHTML from "react-render-html";
import AddButton from "../../../../partials/Buttons/AddButton";
import { UPDATE_INTEREST } from "../../../../queries/patient.query";
import { useMutation } from "react-apollo";
import { CleanMessage } from "../../../../util/app";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../../partials/loading";
import Editor from "../../../../partials/Editor";
import { EventEmitter } from "../../../../event/EventEmitter";
import { EVENT_TARGET, ACTION_TYPE } from "../../../../event/model";
import { sendNotification } from "../../../../sockette";

const PatientInterest = ({ id, interests, isAdmin }) => {
    const [_interests, setInterests] = useState(interests);
    const [update, setUpdate] = useState(false);

    const [updateFunc, { loading }] = useMutation(UPDATE_INTEREST, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            if (d.UpdateInterest) {
                const { message, doc } = d.UpdateInterest;
                toast.success(message);
                sendNotification(doc, ACTION_TYPE.UPDATE, EVENT_TARGET.PATIENT);
                setUpdate(false);
            }
        },
    });

    EventEmitter.subscribe(EVENT_TARGET.Interest, (event) => setInterests(event));

    return (
        <div className="card">
            <div className="card-head">
                <header>Patient Interest</header>
            </div>
            <div className="card-body min-card">
                <LoadingSpinner loading={loading} bar={true} />
                <div>
                    {!update && (
                        <div className="fade-in">
                            {renderHTML(_interests || "<p>No Interest recorded yet!</p>")}
                            <br />
                        </div>
                    )}

                    {update && (
                        <div className="fade-in">
                            <Editor height={200} content={_interests} onChange={(_data) => setInterests(_data)} />

                            <div className="text-right mt-5 mb-3">
                                <PrimaryButton
                                    title="Update"
                                    onClick={async () => {
                                        if (id && _interests) await updateFunc({ variables: { id, interest: _interests } });
                                        else toast.warn("Patient interest is required!");
                                    }}
                                />
                                <CancelButton
                                    onClick={() => {
                                        setUpdate(false);
                                        setInterests(interests);
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {isAdmin && !update && (
                <div className="card-footer text-right fade-in">
                    <AddButton onClick={() => setUpdate(true)} />
                </div>
            )}
        </div>
    );
};

export default PatientInterest;
